module.exports = __webpack_public_path__ + "img/board.633f2081.svg";